import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

const getSetupProgress = async () => {
  const response = await agent.get(`${API_URL}game-home/setup-progress`)
  return response.data
}

const GameHomeService = {
  getSetupProgress,
}

export default GameHomeService
